module.exports = __webpack_public_path__ + "static/picnic-60be64c18e38ed20d12f3e79ad9a89f6.png";